import { LoadingScreenProps } from "@/types/component"

import "./index.scss"

import React from "react"

const LoadingScreen: React.FC<LoadingScreenProps> = ({ portal }) => {
  const content = (
    <div className="loading-screen">
      <div className="loading-screen__progress-bar"></div>
    </div>
  )

  if (portal) {
    return <div className="loading-screen-portal">{content}</div>
  }

  return content
}

export default LoadingScreen
